import { syncDirtyBudgets } from "containers/Budget/_actions";
import ReactGA from "react-ga4";
import * as api from "api";

const actionTypes = {
    FEED_SUPPLEMENT_SAVE: "FEED_SUPPLEMENT_SAVE",
    FEED_SUPPLEMENT_DELETE: "FEED_SUPPLEMENT_DELETE",
    CANCEL_GET_DRY_MATTER_WEIGHT: "CANCEL_GET_DRY_MATTER_WEIGHT",
};
export default actionTypes;

export const saveFeedSupplement = (farmId, budgetId, feedSupplement) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Supplements",
            action: "Save",
        });
        dispatch({ type: actionTypes.FEED_SUPPLEMENT_SAVE, payload: { farmId, budgetId, feedSupplement } });
        dispatch(syncDirtyBudgets(budgetId));
        resolve();
    });
};

export const deleteFeedSupplement = (farmId, budgetId, id) => (dispatch) => {
    ReactGA.event({
        category: "Supplements",
        action: "Delete",
    });
    dispatch({ type: actionTypes.FEED_SUPPLEMENT_DELETE, payload: { farmId, budgetId, id } });
    dispatch(syncDirtyBudgets(budgetId));
};

export const getDryMatterWeight = (farmId, budgetId, feedSupplements) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Supplements",
            action: "GetDryMatterWeight",
        });

        if (!feedSupplements || feedSupplements.length === 0 || !feedSupplements[0].category) {
            reject([{ dryMatterWeightInTonnes: 0, dryMatterWeightPerHectare: 0 }]);
        } else {
            dispatch({ type: actionTypes.CANCEL_GET_DRY_MATTER_WEIGHT });
            dispatch(
                api.post({
                    path: `farms/${farmId}/budgets/${budgetId}/feedSupplementDryWeight`,
                    content: { feedSupplements },
                    onSuccess: (response) => {
                        resolve(response);
                        return [];
                    },
                    onFailure: (error) => {
                        error.handled = true;
                        reject([{ dryMatterWeightInTonnes: 0, dryMatterWeightPerHectare: 0 }]);
                        return [];
                    },
                    cancelActionType: actionTypes.CANCEL_GET_DRY_MATTER_WEIGHT,
                })
            );
        }
    });
};
